import { Badge } from "@/components/ui/badge";
import type { ListingType, PropertyStatus } from "@/types/property";

interface PropertyStatusBadgeProps {
  status: PropertyStatus;
  listingType: ListingType;
  className?: string;
}

function labelFor(status: PropertyStatus, listingType: ListingType): string {
  switch (status) {
    case "AVAILABLE":
      return listingType === "SALE" ? "Đang bán" : "Đang cho thuê";
    case "DEPOSIT":
      return "Đặt cọc";
    case "SOLD":
      return "Đã bán";
    case "RENTED":
      return "Đã thuê";
  }
}

function variantFor(status: PropertyStatus): "success" | "warning" | "neutral" {
  switch (status) {
    case "AVAILABLE":
      return "success";
    case "DEPOSIT":
      return "warning";
    case "SOLD":
    case "RENTED":
      return "neutral";
  }
}

export function PropertyStatusBadge({ status, listingType, className }: PropertyStatusBadgeProps) {
  const label = labelFor(status, listingType);
  return (
    <Badge variant={variantFor(status)} dot aria-label={label} className={className}>
      {label}
    </Badge>
  );
}
